<template>
  <div class="warp">
    <div class="company_heard_tool">
      <el-button type="warning" size="mini" icon="el-icon-refresh" @click="refresh">刷新</el-button>
      <el-button type="danger" size="mini" icon="el-icon-delete" @click="delList">删除</el-button>
    </div>
    <!-- 头部工具栏 -->
    <el-form ref="screenForm" :inline="true" class="demo-form-inline">
      <el-form-item label="公司：" prop="companyName">
        <el-input v-model="screenForm.companyName" />
      </el-form-item>
      <el-form-item label="微信手机：" prop="memberPhone">
        <el-input v-model="screenForm.memberPhone" />
      </el-form-item>
      <el-form-item label="姓名：" prop="name">
        <el-input v-model="screenForm.name" />
      </el-form-item>
      <el-button type="primary" size="mini" icon="el-icon-search" style="margin-right: 10px" @click="screenData">筛选</el-button>
    </el-form>
    <div ref="tableWrap" style="flex: 1">
      <el-table
        v-if="tableH"
        ref="table"
        v-loading="loading"
        :max-height="tableH - 47"
        :data="tableData"
        tooltip-effect="dark"
        :stripe="true"
        :border="true"
        size="mini"
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column type="index" label="#" width="50" /> -->
        <el-table-column type="selection" width="55" />
        <el-table-column prop="companyName" label="公司" />
        <el-table-column label="状态" width="100" prop="statusStr">
          <template slot-scope="scope">
            <div style="color: #606266">{{ scope.row.status == 0 ? '审核中' : scope.row.status == 1 ? '审核通过' : '审核拒绝' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="微信手机" />
        <el-table-column prop="name" label="姓名" />
        <el-table-column prop="zhiwei" label="职位" />
        <el-table-column prop="contact" label="联系方式" />
        <el-table-column prop="createDate" label="申请时间" />
        <el-table-column prop="address" label="操作">
          <template slot-scope="scope">
            <div v-if="scope.row.status == 0">
              <el-button type="primary" size="mini" @click="accept(scope.row.id)">审核通过</el-button>
              <el-button type="danger" size="mini" style="margin: 6px 0 0" @click="reject(scope.row.id)">审核拒绝</el-button>
            </div>
            <div v-else>{{ scope.row.status == 0 ? '审核中' : scope.row.status == 1 ? '审核通过' : '审核拒绝' }}</div>
          </template>
        </el-table-column>
      </el-table>
      <div style="padding: 15px 0 0">
        <el-pagination
          :current-page="page.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page.pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
import pagination from '@/mixins/pagination'
import md5 from 'js-md5' // 引入Md5加密
import { deepClone } from '@/utils'
export default {
  mixins: [pagination],
  data() {
    return {
      tableData: [],
      tableH: 0,
      screenForm: {
        companyName: '',
        memberPhone: '',
        name: '',
        reason: '', // 拒绝原因
        multipleSelection: []
      }
    }
  },
  mounted() {
    this.getTableList()
    this.tableH = this.$refs.tableWrap.clientHeight
  },
  methods: {
    // 选择或者取消行，支持全选
    handleSelectionChange(val) {
      this.multipleSelection = val
      // console.log(val)
    },
    // 批量删除
    delList() {
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info('您并没有选中任何数据')
      }
      var ids = []
      this.multipleSelection.forEach((item) => {
        ids.push(item.id)
      })
      console.log(ids)
      var params = {
        ids: ids.toString()
      }
      this.$api.advance
        .yuzhiJoinCompanyDel(params)
        .then((res) => {
          console.log(res)
          this.$message.success(res)
          this.refresh()
        })
        .catch((err) => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
    },
    getTableList() {
      this.loading = true
      this.$api.advance
        .joinCompanyList(this.page)
        .then((res) => {
          this.tableData = res.records
          const comIds = res.records
            .map((item) => item.companyId)
            .filter((id) => id)
            .join(',')
          this.getCompanyNameByIds({ ids: comIds })
          this.total = res.total
          this.loading = false
          const ids = res.records.map((item) => item.memberId).join(',')
          this.getMemberByIds({ ids })
        })
        .catch((e) => {})
    },
    getMemberByIds(data) {
      return this.$api.member
        .reqMemberByIds(data)
        .then((res) => {
          console.log('res', res)
          this.tableData.forEach((item) => {
            this.$set(item, 'phone', res[item.memberId] && res[item.memberId].phone)
          })
          this.loading = false
        })
        .catch(() => {})
    },
    getCompanyNameByIds(data) {
      return this.$api.company
        .reqCompanyByIds(data)
        .then((res) => {
          this.tableData.forEach((item) => {
            this.$set(item, 'companyName', res[item.companyId] && res[item.companyId].companyName)
          })
          this.loading = false
        })
        .catch(() => {})
    },
    refresh() {
      this.page = {
        pageNumber: 1,
        pageSize: 10
      }
      this.$refs.screenForm.resetFields()
      Promise.all([this.getTableList()])
        .then(() => {
          this.loading = false
        })
        .catch(() => {})
    },
    screenData() {
      this.page = {
        pageNumber: 1,
        pageSize: 10
      }
      Object.assign(this.page, this.screenForm)
      this.getTableList()
    },
    accept(id) {
      this.$confirm('确定通过？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.advance
          .accept({ id })
          .then((res) => {
            console.log(res, 'res')
            Object.assign(this.page, this.screenForm)
            this.getTableList()
          })
          .catch((e) => {})
      })
    },
    reject(id) {
      this.$prompt('请输入拒绝原因，拒绝原因不能为空', '拒绝原因', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: '',
        inputValidator(value) {
          if (value == undefined) {
            return '拒绝原因不能为空'
          }
        },
        inputErrorMessage: '请输入拒绝原因'
      })
        .then((items) => {
          console.log(items, 121254)
          this.$api.advance
            .reject({
              id: id,
              rejectReason: items.value
            })
            .then((res) => {
              console.log(res, 'res')
              Object.assign(this.page, this.screenForm)
              this.$message({
                type: 'success',
                message: '成功'
              })
              this.getTableList()
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          })
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.warp {
  font-size: 14px;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 84px);
  .company_heard_tool {
    margin-bottom: 10px;
  }
}
</style>
